import { Accessor, ParentProps, Setter, Show, createContext, createMemo, createSignal, useContext } from "solid-js"
import { useTable } from "../TableContext"
import style from '../st-table.module.css'


interface SuperTitleProps extends ParentProps {
    title: string
}

class SuperTitleContext {
    depth: number = 0
    parent: SuperTitleContext | undefined = undefined
    columnIds: Accessor<string[]>
    private setColumnIds: Setter<string[]> 

    columnStart: Accessor<number>
    private setColumnStart: Setter<number>

    columnEnd: Accessor<number>
    private setColumnEnd: Setter<number>

    constructor(parent?: SuperTitleContext) {
        this.parent = parent;
        this.depth = parent ? parent.depth + 1 : 0;
        [this.columnIds, this.setColumnIds] = createSignal<string[]>([]);
        [this.columnStart, this.setColumnStart] = createSignal<number>(0);
        [this.columnEnd, this.setColumnEnd] = createSignal<number>(0);
    }

    registerColumn(id: string) {
        this.setColumnIds((ids) => [...ids, id])
        this.parent?.registerColumn(id)
    }
}
const _SuperTitleContext = createContext<SuperTitleContext>()
export const useSuperTitle = () => useContext(_SuperTitleContext)

export const SuperTitle = (props: SuperTitleProps) => {
    const table = useTable();
    const parentSuperTitle = useSuperTitle();
    const context = new SuperTitleContext(parentSuperTitle);

    const columnIndices = createMemo(() => {
        return context.columnIds().filter(id => !table.hiddenColumnIds().includes(id)).map((id) => table.visibleColumnIds().indexOf(id))
    })

    const colStart = createMemo(() => columnIndices().reduce((acc, idx) => Math.min(acc, idx), Infinity))
    const colEnd = createMemo(() => columnIndices().reduce((acc, idx) => Math.max(acc, idx), -Infinity))
    const rowStart = createMemo(() => parentSuperTitle ? parentSuperTitle.depth + 2 : 1);
    const rowEnd = createMemo(() => rowStart() + 1);

    const hideSupertitle = () => {
        for (const id of context.columnIds()) {
            table.toggleColumnVisibility(id, false);
        }
    }

    return (
        <_SuperTitleContext.Provider value={context}>
            <Show when={columnIndices().length}>
                <th class={style['st-table-head-cell']}
                    style={`grid-column-start: ${colStart() + 1}; grid-column-end: ${colEnd() + 2}; grid-row-start: ${rowStart()}; grid-row-end: ${rowEnd()};`}
                    onClick={hideSupertitle}
                >
                    {props.title}
                </th>
            </Show>
            {props.children}
        </_SuperTitleContext.Provider>
    )
}